import type { App, Plugin } from 'vue';
import PrimeVue from 'primevue/config';
import type { PrimeVueConfiguration } from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';
import { DEFAULT_IS_PRIMEVUE_OPTIONS } from '../prime/default-prime-vue-options';

export interface IsUiKitPluginOptions {
  /**
   * Opciones de PrimeVue. Se fusionan (merge profundo de theme) con los defaults
   * de Interseguro definidos en default-prime-vue-options.ts.
   * Cada microfrontend puede sobreescribir preset, tokens, pt, etc.
   */
  primeVue?: PrimeVueConfiguration;
  /**
   * Registrar ConfirmationService globalmente (default: true).
   */
  confirmationService?: boolean;
  /**
   * Registrar DialogService globalmente (default: true).
   */
  dialogService?: boolean;
  /**
   * Registrar ToastService globalmente (default: true).
   */
  toastService?: boolean;
}

function mergeOptions(
  base: PrimeVueConfiguration,
  override?: PrimeVueConfiguration,
): PrimeVueConfiguration {
  if (!override) return base;

  return {
    ...base,
    ...override,
    theme:
      override.theme !== undefined
        ? { ...(base.theme as object), ...(override.theme as object) }
        : base.theme,
    locale:
      override.locale !== undefined
        ? { ...base.locale, ...override.locale }
        : base.locale,
  };
}

export function createIsUiKitPlugin(options?: IsUiKitPluginOptions): Plugin {
  return {
    install(app: App) {
      const merged = mergeOptions(DEFAULT_IS_PRIMEVUE_OPTIONS, options?.primeVue);
      app.use(PrimeVue, merged);

      if (options?.confirmationService !== false) {
        app.use(ConfirmationService);
      }
      if (options?.dialogService !== false) {
        app.use(DialogService);
      }
      if (options?.toastService !== false) {
        app.use(ToastService);
      }
    },
  };
}

export { DEFAULT_IS_PRIMEVUE_OPTIONS };
